import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { FaMinus, FaPlus } from "react-icons/fa";
const ToggleSection = ({ title, children, initiallyOpen = true }) => {
    const [isOpen, setIsOpen] = useState(initiallyOpen);
    return (_jsxs("div", { className: "border border-gray-300 rounded mb-4", children: [_jsxs("div", { className: "flex items-center justify-between bg-gray-100 px-4 py-2", onClick: () => setIsOpen((prev) => !prev), children: [_jsx("h3", { className: "font-semibold", children: title }), _jsx("div", { className: "text-sm text-blue-600 hover:underline", children: isOpen ? _jsx(FaMinus, {}) : _jsx(FaPlus, {}) })] }), isOpen && _jsx("div", { className: "p-4", children: children })] }));
};
export default ToggleSection;
